export enum BookingServiceItemStateEnum {
    ItemWithBrandCard = 0,
    ItemWithInstructionsCard = 1,
    ItemWithEditCard = 2
}
